import ReactDOM from 'react-dom/client';

import './assets/index.css';
import casinoConfig from '@dcentralexpedientedigital/config';
import {
    initializeSentry,
    sentryErrorHandler,
} from '@dcentralexpedientedigital/fe-shared/services/sentry';
import { setAssetBaseUrl } from '@dcentralexpedientedigital/fe-ui/utils/assets';
import { storeMarketingParams } from '@dcentralexpedientedigital/fe-ui/utils/marketing-params';

import { AppRoot } from './components/app-root.tsx';
import { router } from './routes.tsx';
import { initializeFlowsHandler } from './utils/flows.ts';
import { injectRootTheme } from './utils/inject-root-theme';
import { initializeLiveChatHandler } from './utils/live-chat.ts';
import { handleMagicLinkAuth } from './utils/process-magic-link-auth.ts';
import { checkRequiredAction } from './utils/required-action';

setAssetBaseUrl(casinoConfig.imageBaseUrl);

checkRequiredAction();

async function main() {
    // if (import.meta.env.DEV) {
    //     const { createMockApi } = await import('@dcentralexpedientedigital/mock-api');
    //     createMockApi({
    //         environment: 'development',
    //         urlPrefix: 'http://localhost:5173',
    //         passthroughs: [
    //             casinoConfig.cmsBaseUrl,
    //             casinoConfig.pamBaseUrl,
    //             casinoConfig.dataPlatformBaseUrl,
    //             casinoConfig.authConfig.authority,
    //         ],
    //     });
    // }

    storeMarketingParams(casinoConfig.generalConfig?.marketingSourceValidators ?? []);

    // Process magic link / OIDC response early so the guard can proceed
    await handleMagicLinkAuth();
    await injectRootTheme(casinoConfig.themes.light);

    initializeSentry({
        tenantId: casinoConfig.tenantId,
        brand: casinoConfig.name,
        dsn: casinoConfig.sentryDsn,
        router,
    });

    if (casinoConfig.liveChat?.enabled && casinoConfig.liveChat.scriptSourceUrl) {
        const liveChat = initializeLiveChatHandler(casinoConfig.liveChat, router);
        // Cleanup will be called when the app is unmounted
        window.addEventListener('unload', liveChat.cleanup);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flowsConfig = (casinoConfig as any).flows;
    if (flowsConfig?.enabled && flowsConfig?.apiUrl) {
        const flows = initializeFlowsHandler(flowsConfig, router);
        // Cleanup will be called when the app is unmounted
        window.addEventListener('unload', flows.cleanup);
    }

    ReactDOM.createRoot(document.getElementById('root')!, {
        onRecoverableError: sentryErrorHandler(),
    }).render(<AppRoot />);
}

main();
